// @flow
import React from 'react';
import { MdChevronRight } from 'react-icons/lib/md';


import styles from './expandIcon.css';

type ExpandIconPropTypes = {
  isActive?: boolean,
};

const ExpandIcon = ({ isActive }: ExpandIconPropTypes) => (
  <MdChevronRight
    className={
      `
        ${styles.expandIcon}
        ${isActive ? styles.active : ''}
      `
    }
    size={24}
  />
);

export default ExpandIcon;



// WEBPACK FOOTER //
// ./src/scripts/components/Accordion/ExpandIcon/index.jsx